// extracted by mini-css-extract-plugin
module.exports = {"mainComponent":"style_mainComponent__4KENS","mainContent":"style_mainContent__1DFqj","rightContainer":"style_rightContainer__ljZNy"};